import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
const IdentificationCardPartenaire = ({ title, details, ids }) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [contactDetails, setContactDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("auth_token_" + api);
  const [editedDetails, setEditedDetails] = useState({});
  const [editMode, setEditMode] = useState(false);
  const toggleEditMode = () => setEditMode(!editMode);
  const styles = {
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
    }),
  };
  const handleInputChange = (key, value) => {
    setEditedDetails((prevDetails) => ({
      ...prevDetails,
      [key]: value,
    }));
    console.log(editedDetails);
  };
  useEffect(() => {
    if (contactDetails) {
      setEditedDetails(contactDetails.detail);
    }
  }, [contactDetails]);
  const sendPostRequestContact = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      // Vérifier la réponse
      if (!response.ok) {
        const errorText = await response.text(); // Lire le texte de l'erreur
        toast.error("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      // Traitement de la réponse
      const data = await response.json();
      return data; // Retourner les données si nécessaire
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message); // Lancer une erreur avec le message original
    }
  };
  const sendPostRequestSociete = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_societe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      // Vérifier la réponse
      if (!response.ok) {
        const errorText = await response.text(); // Lire le texte de l'erreur
        toast.success("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      // Traitement de la réponse
      const data = await response.json();
      return data; // Retourner les données si nécessaire
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message); // Lancer une erreur avec le message original
    }
  };

  const handleSaveChanges = async () => {
    try {
      if (ids.contact_id && ids.societe_id) {
        console.error(
          "Erreur: Les IDs contact et société ne peuvent pas être définis en même temps."
        );
        toast.error(
          "Erreur: Les IDs contact et société ne peuvent pas être définis en même temps."
        );
        return;
      }

      if (ids.contact_id) {
        const requestBody = {
          id: ids.contact_id,
          titre_id: editedDetails.Titre?.value,
          nom: editedDetails.Nom,
          prenom: editedDetails.Prénom,
          societe_id: editedDetails.Société?.value,
          date_de_naissance: editedDetails["Date de naissance"],
          ville_de_naissance: editedDetails["Ville de naissance"],
          departement_ou_pays: editedDetails["Code département de naissance"],
          situation_matrimoniale_id:
            editedDetails["Situation matrimoniale"]?.value,
          profession: editedDetails.Profession,
          adresse: editedDetails.Adresse,
          complement: editedDetails.Complément,
          code_postal: editedDetails["Code postal"],
          ville: editedDetails.Ville,
          pay_id: editedDetails.Pays ? editedDetails.Pays?.value : null,
          tel_fix: editedDetails["Téléphone fixe"],
          tel_mobil: editedDetails["Téléphone mobile"],
          email_pro: editedDetails["Email pro."],
          email_perso: editedDetails["Email perso."],
        };

        // Envoyer la requête POST pour contact
        await sendPostRequestContact(requestBody);
      }

      if (ids.societe_id) {
        const requestBody = {
          id: ids.societe_id,
          raison_sociale: editedDetails["Raison sociale"],
          email: editedDetails.Email,
          telephone: editedDetails.Téléphone,
          fax: editedDetails.Fax,
          formes_juridique_id: editedDetails["Forme juridique"]?.value,
          contact_id: editedDetails["Président (PP)"]?.value,
          societe_id: editedDetails["Président (PM)"]?.value,
          contact2_id: editedDetails["Directeur Général"]?.value,
          adresse: editedDetails.Adresse,
          code_postal: editedDetails["Code postal"],
          ville: editedDetails.Ville,
          pay_id: editedDetails.Pays ? editedDetails.Pays?.value : null,
        };
        console.log(requestBody);
        // Envoyer la requête POST pour société
        await sendPostRequestSociete(requestBody);
      }

      setEditMode(false);

      toggleModal();
    } catch (error) {
      console.error(
        "Erreur lors de l'enregistrement des modifications:",
        error
      );
    }
  };

  const renderField = (key, value) => {
    return editMode ? (
      key == "Titre" ? (
        <Select
          defaultValue={{ label: value.label, value: value.value }}
          options={renderTitreOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Société" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSocieteOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Situation matrimoniale" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSituationMatrimonialeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Pays" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPaysOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Forme juridique" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderFormeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Président (PP)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Directeur Général" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Président (PM)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPresidentOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Date de naissance" ? (
        <InputMask
          mask="99/99/9999"
          value={editedDetails[key]}
          className="form-control input-color"
          onChange={(e) => handleInputChange(key, e.target.value)}
        />
      ) : (
        <>
          <Input
            type="text"
            defaultValue={editedDetails[key]}
            onChange={(e) => handleInputChange(key, e.target.value)}
            required={
              key == "Email perso" || key == "Téléphone mobile" ? true : false
            }
          />
          {(key == "Email perso." || key == "Téléphone mobile") &&
            editedDetails[key]?.trim() === "" && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                Ce champ est obligatoire.
              </div>
            )}
        </>
      )
    ) : (
      <span>
        {typeof value === "object" && value !== null ? value.label : value}
      </span>
    );
  };
  // Select Options
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  /*************************   Formes juridiques         *******************************/
  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const renderFormeOptions = () => {
    return [
      {
        options: formeJuridique.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Formes juridiques         *******************************/

  /*************************   Président PM          *******************************/
  const [presidentData, setPresidentData] = useState({ data: [] });
  const renderPresidentOptions = () => {
    return [
      {
        options: presidentData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END President         *******************************/

  /*************************   Directeur          *******************************/
  const [directeurData, setDirecteurData] = useState({ data: [] });
  const renderDirecteurOptions = () => {
    return [
      {
        options: directeurData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Directeur         *******************************/
  useEffect(() => {
    const fetchData = async () => {
      if (modal && ids?.contact_id) {
        setLoading(true);
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/partenaires/show_contact?contact_id=${ids.contact_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors de la récupération des détails de contact"
            );
          }
          const data = await response.json();
          setContactDetails(data);
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
        getPay();
        getSociete();
        getSituationMatrimoniale();
        getTitre();
      }
      if (modal && ids?.societe_id) {
        setLoading(true);
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/partenaires/show_societe?societe_id=${ids.societe_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors de la récupération des détails de contact"
            );
          }
          const data = await response.json();
          setContactDetails(data);
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
        getDirecteur();
        getFormeJuri();
        getPresident();
        getPay();
      }
    };

    fetchData();
  }, [modal]);
  // useEffect(() => {

  // }, []);

  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: "10px" }}>
        {title}
      </CardTitle>
      <CardBody>
        {Object.entries(details).map(([key, value], index) => (
          <Row className="mb-3" key={index}>
            <Col
              xs={12}
              md={12}
              lg={4}
              className="mb-2 col-md-4"
              style={{ whiteSpace: "nowrap" }}
            >
              {key == "Objet social" ? (
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "11em",
                      paddingTop: "18px",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              ) : (
                // : key == "Classe immobilisation" ? (
                //   <i style={{ color: "#9d9c9c" }}>
                //     <span
                //       style={{
                //         display: "inline-block",
                //         width: "11em",
                //         paddingTop: "18px",
                //       }}
                //     >
                //       {key} :
                //     </span>
                //   </i>
                // )
                <i style={{ color: "#9d9c9c" }}>
                  <span style={{ display: "inline-block", width: "11em" }}>
                    {key} :
                  </span>
                </i>
              )}
            </Col>
            <Col xs={12} md={12} lg={8} className="mb-2 col-md-8">
              <span
                style={{
                  fontFamily: "sans-serif",
                }}
              >
                {typeof value === "number" && key != "Builder" ? (
                  renderValue(
                    value
                      .toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })
                      .replace("€", "")
                  )
                ) : key === "Objet social" ? (
                  <span
                    style={{
                      paddingLeft: "40px",
                      display: "flex",
                      whiteSpace: "pretty",
                    }}
                  >
                    {value}
                  </span>
                ) : key == "Modèle" && ids?.publipostage_id != null ? (
                  <Link
                    to={`http://www.fluxod.com/${api}/publipostages/${ids.publipostage_id}/redirect_to_real_controller`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Partenaire" && ids?.partenaire_id != null ? (
                  <Link
                    to={`http://www.fluxod.com/${api}/partenaires/${ids.partenaire_id}/redirect_to_real_controller`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Investisseur" && ids?.investisseur_id != null ? (
                  <Link
                    to={`${backUrl}/investisseurs/${ids.investisseur_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Impression" && ids?.impression_id != null ? (
                  <Link
                    to={`${backUrl}/impressions/${ids.impression_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "PME" && ids?.pme_id != null ? (
                  <Link
                    to={`${backUrl}/pmes/${ids.pme_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Souscription" && ids?.souscription_id != null ? (
                  <Link
                    to={`${backUrl}/souscriptions/${ids.souscription_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Réservation" && ids?.reservation_id != null ? (
                  <Link
                    to={`${backUrl}/reservations/${ids.reservation_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : key == "Personne Physique" && ids?.contact_id != null ? (
                  <span
                    onClick={toggleModal}
                    className="text-decoration-underline"
                    style={{ color: "#555B21", cursor: "pointer" }}
                  >
                    {value}
                  </span>
                ) : (key == "Personne Morale" || key == "Sociéte") &&
                  ids?.societe_id != null ? (
                  <span
                    onClick={toggleModal}
                    className="text-decoration-underline"
                    style={{ color: "#555B21", cursor: "pointer" }}
                  >
                    {value}
                  </span>
                ) : key == "Comptes associés" ? (
                  <>
                    <span dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                ) : key == "Designation" ? (
                  <>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: value.replace(/\n/g, "<br />"),
                      }}
                    />
                  </>
                ) : key == "Tête de réseau" && ids?.partenaire_id != null ? (
                  <Link
                    to={`${backUrl}/partenaires_cgps/${ids.partenaire_id}`}
                    className="text-decoration-underline"
                    style={{
                      color: "#555B21",
                    }}
                  >
                    {value}
                  </Link>
                ) : (
                  renderValue(value)
                )}
              </span>
            </Col>
          </Row>
        ))}
      </CardBody>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Détails</ModalHeader>
        <ModalBody>
          {" "}
          <Row className="mb-3">
            {contactDetails &&
              Object.entries(contactDetails.detail).map(
                ([key, value], index) => (
                  <>
                    <Col xs={12} md={6} className="mb-2">
                      <Label
                        className="font-weight-bold"
                        style={{ paddingTop: editMode ? 10 : 0 }}
                      >
                        {key} :
                      </Label>{" "}
                      {renderField(key, value)}
                    </Col>
                  </>
                )
              )}
          </Row>
        </ModalBody>
        <ModalFooter>
          {editMode ? (
            <>
              <Button color="success" onClick={handleSaveChanges}>
                Sauvegarder
              </Button>
              <Button color="secondary" onClick={toggleEditMode}>
                Annuler
              </Button>
            </>
          ) : (
            <Button color="secondary" onClick={toggleEditMode}>
              Modifier
            </Button>
          )}
          <Button color="secondary" onClick={toggleModal}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return "";
  } else if (
    value === "Validé" ||
    value === "Validée" ||
    value === "Finalisée" ||
    value === "Dossier de souscription CGP" ||
    value === "Dossier payé" ||
    value === "Oui"
  ) {
    return (
      <span
        className="bg-success badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else if (value === "Dossier complet") {
    return (
      <span
        className="badge"
        style={{
          fontSize: "100%",
          backgroundColor: "#33A133",
        }}
      >
        {" "}
        {value}
      </span>
    );
  } else if (value === "Dossier validé") {
    return (
      <span
        className="badge"
        style={{
          fontSize: "100%",
          backgroundColor: "#66C266",
        }}
      >
        {" "}
        {value}
      </span>
    );
  } else if (
    value === "En attente" ||
    value === "Commercialisation" ||
    value === "Optionnelle - à confirmer" ||
    value === "En cours"
  ) {
    return (
      <span className="bg-info badge bg-secondary" style={{ fontSize: "100%" }}>
        {value}
      </span>
    );
  } else if (
    value === "Ferme - en attente d'allocation" ||
    value === "Ferme - Rompu à rembourser" ||
    value === "Abandonnée" ||
    value === "Radiée" ||
    value === "Annulée" ||
    value === "Cloturée" ||
    value === "Non"
  ) {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};

export default IdentificationCardPartenaire;
